import { useHistory, useParams } from "react-router-dom";
import DetailsHeader from "components/common/Details/DetailsHeader/DetailsHeader";
import SectionWrapper from "components/common/section/SectionWrapper/SectionWrapper";
import { ReactComponent as LinkIcon } from "assets/images/icons/link.svg";
import DetailSection from "./DetailSection";
import { walletResponse } from "../../helpers/data";
import CardTable from "../../BankingWallets/WalletCard/CardTable";
import SideTabs from "utils/SideTabs/SideTabs";

function AccountDetails() {
	const history = useHistory();
	const { id } = useParams();
	return (
		<SectionWrapper
			cls="pb-0"
			containerCls="d-flex flex-wrap"
			routeName={
				<DetailsHeader
					detailID={id}
					icon={<LinkIcon className="me-3" />}
					IDName="Account Id"
					returnAction={() => history.push("/banking/wallets")}
					tabName="Banking Wallets"
				/>
			}
			navTabChildren={
				<div className="d-flex">
					<button className="btn btn--sm btn--secondary--bordered me-4"></button>
					<button className="btn btn--sm btn--secondary--bordered me-4"></button>
				</div>
			}
		>
			<SideTabs
				tabComponent={[
					{
						name: "Naira Card - Virtual",
						id: "Naira Card-Virtual",
						Comp: (
							<>
								<div className="border-bottom">
									<DetailSection res={walletResponse} />
								</div>
								<CardTable />
							</>
						),
					},
					{
						name: "Naira Card - Physical",
						id: "Naira Card-Physical",
						Comp: <h4>Not Available</h4>,
					},
					{
						name: "USD Card - Virtual",
						id: "USD Card-Virtual",
						Comp: <h4>Not Available</h4>,
					},
				]}
			/>
			
		</SectionWrapper>
	);
}

export default AccountDetails;
